module.exports = __webpack_public_path__ + "3fd8dd13af99a9e90d07ee32607993d3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/border-center.png
// module id = 687
// module chunks = 0